import { all, put, takeEvery, call } from 'redux-saga/effects';
import apis from '@src/apis';
import { setAuthAccessToken } from '@src/apis/api';
import {
  applyDocumentBranding,
  buildBrandingFromTenant,
  getCachedBranding,
  setCachedBranding,
  PLATFORM_BRANDING,
} from '@src/utils/branding';
import actions from '../actions';

// Fetch the logged-in tenant's branding, apply it to the theme/document and
// refresh the localStorage cache. Failures are swallowed so a branding issue
// never blocks the authenticated session.
function* loadTenantBrandingSaga() {
  try {
    const { status, result } = yield apis.tenant.getTenant();
    if (!status || !result) return;

    const branding = buildBrandingFromTenant(result);
    setCachedBranding(branding);
    yield put(actions.theme.setBranding(branding));
    applyDocumentBranding(branding);
  } catch (error) {
    // ignore - keep whatever branding is already applied
  }
}

function* verifyTokenSaga({ accessToken }) {
  try {
    const { status, result } = yield apis.auth.verifyToken(accessToken);
    if (!status) throw new Error();

    setAuthAccessToken(accessToken);

    yield put(actions.auth.verifyTokenSuccess(accessToken, result));

    // Only after a verified session do we fetch + apply tenant branding.
    yield loadTenantBrandingSaga();
  } catch (error) {
    yield put(actions.auth.verifyTokenFailure());
  }
}

function* logoutSaga() {
  // Keep the cached tenant branding so the login screen still shows it after
  // logout (only overwritten when another tenant logs in). Just re-apply the
  // document-level branding (title/favicon).
  yield call(applyDocumentBranding, getCachedBranding() || PLATFORM_BRANDING);
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.auth.actionTypes.VERIFY_TOKEN, verifyTokenSaga),
    takeEvery(actions.auth.actionTypes.LOGOUT, logoutSaga),
  ]);
}
